import { DocsExamples } from "@/types/docs-reference";

import primary from "./primary.mml";

export const examples: DocsExamples = {
  primary: {
    title: "Basic m-position-probe",
    description: "This is a basic m-position-probe.",
    code: primary,
  },
};
